import {defaults} from 'lodash'

export default {
  getters: {
    FlightInfo: (state, getters) => {

      return defaults(
        getters.currentTripDashboardId
          ? getters.Trips[getters.currentTripDashboardId].flight_info
          : {},
        {
          'section-heading': 'Flight Information',
          'section-subheading': '',
          'cta_enabled': true,
          'client_flight_info': getters.Trips[getters.currentTripDashboardId]?.client_flight_info ?? '',
          'cta-block-content': getters.Trips[getters.currentTripDashboardId]['cta-block-content'] ?? ''
        }
      )
    },
  }
}
